import { createContext, useContext } from 'react';

import { EditMode, IDE_MODE_TYPE } from '../types';
const IDEModeContext = createContext<IDE_MODE_TYPE>(EditMode.disabled);

export function IDEModeProvider({ value, children }: { value: IDE_MODE_TYPE; children: React.ReactNode }) {
  return <IDEModeContext.Provider value={value}>{children}</IDEModeContext.Provider>;
}
export function useIDEMode() {
  return useContext(IDEModeContext);
}
